var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoniepointM(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 236,
    viewBox: "0 0 239 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.567 235.485H118.713C63.5011 235.344 26.5032 223.968 18.819 216.945C10.7079 209.782 0.0354004 172.703 0.0354004 117.927C0.0354004 63.2911 10.7079 26.0715 18.819 18.9084C26.5032 11.8859 63.6434 0.509287 118.713 0.368835H119.567C174.78 0.509287 211.778 11.8859 219.462 18.9084C227.573 26.0715 238.245 63.2911 238.245 117.927C238.245 172.562 227.573 209.782 219.462 216.945C211.778 224.108 174.78 235.485 119.567 235.485Z",
    fill: "#0357EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_238_1086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.065 124.949L169.511 70.0327H142.047C142.047 70.0327 121.129 112.309 119.279 118.067H118.995L96.9382 70.0327H69.3321L64.7785 117.646L60.9364 165.961H77.7278C84.9851 165.961 87.8311 162.871 88.4003 155.287C88.4003 155.287 91.2462 111.045 90.8193 104.584H91.1039L91.9577 107.533C93.0961 111.466 108.749 149.247 108.749 149.247H129.383C129.383 149.247 145.036 112.028 147.028 104.584H147.312L149.731 155.287C150.301 162.871 153.289 165.961 160.404 165.961H177.195L174.065 124.949Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_238_1086",
    x: 60.9364,
    y: 70.0327,
    width: 116.259,
    height: 97.9283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_238_1086"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_238_1086",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoniepointM);
export default __webpack_public_path__ + "static/media/MoniepointM.fac6abc48e01d55e7ad5391714674c1b.svg";
export { ForwardRef as ReactComponent };